import { CooperativeSearchSelect } from '@/components/form-fields';
import type { FormBuilderOptionItem } from '@/components/generic-form';
import { FarmerSourceDocumentType } from '@/types/enums';

const SOURCE_DOCUMENT_TYPE_OPTIONS = [
  { value: FarmerSourceDocumentType.RA, label: 'Rainforest Alliance' },
  { value: FarmerSourceDocumentType.FT, label: 'Fairtrade' },
  { value: FarmerSourceDocumentType.MERIDIA_DOCUMENT, label: 'Meridia' },
];

export const getFormFields = (): FormBuilderOptionItem[] => {
  return [
    {
      name: 'farmerId',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.farmerId',
      },
      rules: [{ max: 50 }],
    },
    {
      name: 'firstName',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.firstName',
      },
      rules: [{ max: 100 }],
    },
    {
      name: 'lastName',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.lastName',
      },
      rules: [{ max: 100 }],
    },
    {
      name: 'cooperativeIds',
      componentName: 'dropdown',
      component: CooperativeSearchSelect,
      permissionName: 'farmer',
      params: {
        i18nLabel: 'farmers.cooperative',
        allowClear: true,
        mode: 'multiple',
      },
    },
    {
      name: 'gender',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.gender',
      },
      rules: [{ max: 50 }],
    },
    {
      name: 'phone',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.phone',
      },
      rules: [{ max: 50 }],
    },
    {
      name: 'dob',
      componentName: 'datepicker',
      params: {
        i18nLabel: 'farmers.dob',
      },
    },
    {
      name: 'nationalId',
      componentName: 'input',
      params: {
        i18nLabel: 'farmers.nationalId',
      },
      rules: [{ max: 100 }],
    },
    {
      name: 'sourceDocumentType',
      componentName: 'dropdown',
      params: {
        i18nLabel: 'farmers.sourceDocumentType',
        options: SOURCE_DOCUMENT_TYPE_OPTIONS,
      },
    },
  ];
};
